/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_AddressInputs */

const en_case_field_driver_address = /** @type {(inputs: Case_Field_Driver_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const pt_br2_case_field_driver_address = /** @type {(inputs: Case_Field_Driver_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Case_Field_Driver_AddressInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_address = /** @type {((inputs?: Case_Field_Driver_AddressInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_AddressInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_address(inputs)
	return pt_br2_case_field_driver_address(inputs)
});